import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeFiveComponent } from './components/pages/home-five/home-five.component';
import { PreloaderComponent } from './components/common/preloader/preloader.component';
import { NavbarComponent } from './components/common/navbar/navbar.component';
import { FooterComponent } from './components/common/footer/footer.component';
import { AboutSaraComponent } from './components/pages/about-sara/about-sara.component';
import { AboutStyleTwoComponent } from './components/pages/about-style-two/about-style-two.component';
import { FaqComponent } from './components/pages/faq/faq.component';
import { LoginComponent } from './components/pages/login/login.component';
import { RegisterComponent } from './components/pages/register/register.component';
import { ForgotPasswordComponent } from './components/pages/forgot-password/forgot-password.component';
import { ErrorComponent } from './components/pages/error/error.component';
import { TermsOfServiceComponent } from './components/pages/terms-of-service/terms-of-service.component';
import { PrivacyPolicyComponent } from './components/pages/privacy-policy/privacy-policy.component';
import { ContactUsComponent } from './components/pages/contact-us/contact-us.component';
import { IndustriesComponent } from './components/pages/industries/industries.component';
import { TechnologyExpertiseComponent } from './components/pages/technology-expertise/technology-expertise.component';
import { AboutSaraIndiaFamilyComponent } from './components/pages/about-sara-india-family/about-sara-india-family.component';
import { AboutOurLeadershipComponent } from './components/pages/about-our-leadership/about-our-leadership.component';
import { EventsGallaryComponent } from './components/pages/events-gallary/events-gallary.component';
import { TestingServicesComponent } from './components/pages/testing-services/testing-services.component';
import { ManualTestingServicesComponent } from './components/pages/manual-testing-services/manual-testing-services.component';
import { DevelopmentServicesComponent } from './components/pages/development-services/development-services.component';
import { ResourceManagementServicesComponent } from './components/pages/resource-management-services/resource-management-services.component';
import { DataAnalyticsServicesComponent } from './components/pages/data-analytics-services/data-analytics-services.component';
import { ApplicationManagementServicesComponent } from './components/pages/application-management-services/application-management-services.component';
import { AutomationTestingServicesComponent } from './components/pages/automation-testing-services/automation-testing-services.component';
import { UITestingServicesComponent } from './components/pages/ui-testing-services/ui-testing-services.component';
import { ApiTestingServicesComponent } from './components/pages/api-testing-services/api-testing-services.component';
import { DatabaseTestingServicesComponent } from './components/pages/database-testing-services/database-testing-services.component';
import { WebDevelopmentServicesComponent } from './components/pages/web-development-services/web-development-services.component';
import { MobileDevelopmentServicesComponent } from './components/pages/mobile-development-services/mobile-development-services.component';
import { DesktopDevelopmentServicesComponent } from './components/pages/desktop-development-services/desktop-development-services.component';
import { EcommerceDevelopmentServicesComponent } from './components/pages/ecommerce-development-services/ecommerce-development-services.component';
import { AutomationServicesComponent } from './components/pages/automation-services/automation-services.component';
import { ProfessionalResourcingServicesComponent } from './components/pages/professional-resourcing-services/professional-resourcing-services.component';
import { SoftwareOutsourcingServicesComponent } from './components/pages/software-outsourcing-services/software-outsourcing-services.component';
import { ItConsultingServicesComponent } from './components/pages/it-consulting-services/it-consulting-services.component';
import { DBDevelopmentServicesComponent } from './components/pages/db-development-services/db-development-services.component';
import { ReportingServicesComponent } from './components/pages/reporting-services/reporting-services.component';
import { PowerBIServicesComponent } from './components/pages/powerbi-services/powerbi-services.component';
import { InfrastructureManagementServicesComponent } from './components/pages/Infrastructure-management-services/Infrastructure-management-services.component';
import { CloudManagementServicesComponent } from './components/pages/cloud-management-services/cloud-management-services.component';
import { SupportMaintenanceServicesComponent } from './components/pages/support-maintenance-services/support-maintenance-services.component';
import { ServicesContactInfoComponent } from './components/pages/services-contact-info/services-contact-info.component';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { AppInterceptor } from './helpers/appInterceptor';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgxCaptchaModule } from 'ngx-captcha';
import { CareersComponent } from './components/pages/careers/careers.component';
import { JobdetailsComponent } from './components/pages/jobdetails/jobdetails.component';
import { ApplyjobComponent } from './components/pages/applyjob/applyjob.component';
import { CustomPipe } from "./helpers/customPipe.module";
@NgModule({
  declarations: [
    AppComponent,
    HomeFiveComponent,
    PreloaderComponent,
    NavbarComponent,
    FooterComponent,
    AboutSaraComponent,
    AboutSaraIndiaFamilyComponent,
    AboutOurLeadershipComponent,
    EventsGallaryComponent,
    AboutStyleTwoComponent,
    FaqComponent,
    LoginComponent,
    RegisterComponent,
    ForgotPasswordComponent,
    ErrorComponent,
    TermsOfServiceComponent,
    PrivacyPolicyComponent,
    ManualTestingServicesComponent,
    ContactUsComponent,
    IndustriesComponent,
    TechnologyExpertiseComponent,
    TestingServicesComponent,
    DevelopmentServicesComponent,
    ResourceManagementServicesComponent,
    DataAnalyticsServicesComponent,
    ApplicationManagementServicesComponent,
    AutomationTestingServicesComponent,
    UITestingServicesComponent,
    ApiTestingServicesComponent,
    DatabaseTestingServicesComponent,
    WebDevelopmentServicesComponent,
    MobileDevelopmentServicesComponent,
    DesktopDevelopmentServicesComponent,
    EcommerceDevelopmentServicesComponent,
    AutomationServicesComponent,
    ProfessionalResourcingServicesComponent,
    SoftwareOutsourcingServicesComponent,
    ItConsultingServicesComponent,
    DBDevelopmentServicesComponent,
    ReportingServicesComponent,
    PowerBIServicesComponent,
    InfrastructureManagementServicesComponent,
    CloudManagementServicesComponent,
    SupportMaintenanceServicesComponent,
    ServicesContactInfoComponent,
    ServicesContactInfoComponent,
    CareersComponent,
    JobdetailsComponent,
    ApplyjobComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    HttpClientModule,
    FormsModule,
    NgxCaptchaModule,
    CustomPipe
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AppInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
